import moment from 'moment'
/**
 * 设置 cookie
 * @param {Object} param 需要设置的值
 */
const set = ({ key, value = '', domain, expires, path }) => {
  if (!key) return Promise.reject(new Error('key is invalid'))
  document.cookie =
    `${key}=${value};expires=${expires};path=${path};` +
    (domain ? `domain=${domain};` : '')
  return Promise.resolve()
}

/**
 * 根据 key 获取 cookie
 */
const get = ({ key }) => {
  if (!key) return Promise.reject(new Error('key is invalid'))
  return new Promise((resolve, reject) => {
    const cookieList = document.cookie.split(',')
    const cookie = cookieList.find(cookie => {
      const [cookieKey] = cookie.split('=')
      return cookieKey === key
    })
    if (cookie) {
      const [key, value] = cookie.split('=')
      return resolve({ key, value })
    } else {
      return reject(key)
    }
  })
}

/**
 * 根据 key 查询是否有该 cookie
 * @param {String} key cookie 的键值
 */
const includes = key => {
  if (!key) return false
  const cookieList = document.cookie.split(';')
  // console.log('cookieList=' + cookieList)
  // console.log('cookieList=' + JSON.stringify(cookieList))
  for (let cookie of cookieList) {
    const [cookieKey] = cookie.split('=')
    // console.log('cookieKey=' + cookieKey + 'key=' + key)
    if (cookieKey.trim() === key) {
      return true
    }
  }
  return false
}
// 删除的cookie的域和路径，Cookie域和路径要一样才能被覆盖。否则无法清除
const clear = ({ key, domain, path }) => {
  set({
    key,
    domain,
    path,
    expires: moment()
      .subtract(1, 'days')
      .toDate()
      .toUTCString()
  })
}

export { set, get, includes, clear }



// WEBPACK FOOTER //
// ./src/assets/js/cookie.js